import padStart from 'lodash/padStart'
import moment from 'moment'

function padNum(number) {
  return padStart(number, 2, '0')
}

// Convert duration to formatted string
function durationToStr(duration, dependency) {
  const d = moment.duration(duration, 'seconds')

  if (dependency) {
    const totalHours = moment.duration(dependency).hours()
    return `${totalHours > 0 ? padNum(d.hours()).toString().concat(':') : ''}${padNum(
      d.minutes(),
    )}:${padNum(d.seconds())}`
  }

  return `${d.hours() > 0 ? padNum(d.hours()).toString().concat(':') : ''}${padNum(
    d.minutes(),
  )}:${padNum(d.seconds())}`
}

export default durationToStr
